<app-input-switch class="pn-table-switch"
                  offLabel="{{'admin.toolMaintenancePlans.plans.modal.tools.allTools' | translate}}"
                  onLabel="{{'admin.toolMaintenancePlans.plans.modal.tools.onlySelected' | translate}}"
                  [inline]="true"
                  (inputChange)="onChangeView()">
</app-input-switch>

<app-maintenance-plan-tools-table
                        class="tools"
                        [toolsGrouped]="displayOnlySelected ? selectedTools : tools"
                        [selectedTools]="selectedTools"
                        [isLoading]="loading"
                        [readonly]="isEditMode"
                        [tableConfig]="displayOnlySelected ? selectedToolsConfig : toolConfig"
                        [showFilters]="!displayOnlySelected"
                        [filtersToggle]="!displayOnlySelected"
                        [showPagination]="!displayOnlySelected"
                        [showGroupFilters]="false"
                        [definedGroupers]="false"
                        [showGroupers]="false"
                        [isFilterExpanded]="false"
                        (sortChange)="onToolsSortChange($event)"
                        (filterChange)="onToolsFilterChange($event)"
                        (groupChange)="onToolsGroupChange($event)"
                        (pageChange)="onToolsPageChange($event)"
                        (onToolClicked)="onToolClicked($event)">
</app-maintenance-plan-tools-table>
